"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.literals = literals;
exports.clone = clone;
exports.assertClone = assertClone;
exports.isClone = isClone;
exports.validateClone = validateClone;
exports.prune = prune;
exports.assertPrune = assertPrune;
exports.isPrune = isPrune;
exports.validatePrune = validatePrune;
exports.createClone = createClone;
exports.createAssertClone = createAssertClone;
exports.createIsClone = createIsClone;
exports.createValidateClone = createValidateClone;
exports.createPrune = createPrune;
exports.createAssertPrune = createAssertPrune;
exports.createIsPrune = createIsPrune;
exports.createValidatePrune = createValidatePrune;
/* ===========================================================
    MISCELLANEOUS
      - LITERALS
      - CLONE
      - PRUNE
      - FACTORY FUNCTIONS
==============================================================
    LITERALS
----------------------------------------------------------- */
const NoTransformConfigurationError_1 = require("./transformers/NoTransformConfigurationError");
/** @internal */
function literals() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.literals");
}
/** @internal */
function clone() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.clone");
}
/** @internal */
function assertClone() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.assertClone");
}
/** @internal */
function isClone() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.isClone");
}
/** @internal */
function validateClone() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.validateClone");
}
/** @internal */
function prune() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.prune");
}
/** @internal */
function assertPrune() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.assertPrune");
}
/** @internal */
function isPrune() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.isPrune");
}
/** @internal */
function validatePrune() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.validatePrune");
}
/** @internal */
function createClone() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.createClone");
}
/** @internal */
function createAssertClone() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.createAssertClone");
}
/** @internal */
function createIsClone() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.createIsClone");
}
/** @internal */
function createValidateClone() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.createValidateClone");
}
/** @internal */
function createPrune() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.createPrune");
}
/** @internal */
function createAssertPrune() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.createAssertPrune");
}
/** @internal */
function createIsPrune() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.createIsPrune");
}
/** @internal */
function createValidatePrune() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("misc.createValidatePrune");
}
//# sourceMappingURL=misc.js.map